module.exports = __webpack_public_path__ + "img/currentLocation.8527fb63.png";